import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, [
      _createElementVNode("rect", {
        width: "16",
        height: "16",
        x: "4",
        y: "4",
        rx: "2"
      }),
      _createElementVNode("path", { d: "M8 11v5M8 8v.01M12 16v-5M16 16v-3a2 2 0 0 0-4 0" })
    ], -1)
  ])))
}
export default { render: render }